/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["contact .form-container{min-height:calc(100vh - 70px);background:#fafafa;padding:25px;display:flex}contact form{background-color:#fff;box-shadow:1px 0 20px rgba(0,0,0,.05);border:none;width:675px;max-width:100%;padding:25px;margin:auto}contact form h1{font-weight:300;margin:0}contact form p{margin:5px 0 35px}"];
export { styles as styles };
